import { TokenStorage } from "./token-storage.service";
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, of, Subject, throwError } from "rxjs";
import { User } from "../_models/user.model";
import { Permission } from "../_models/permission.model";
import { Role } from "../_models/role.model";
import { catchError, map, tap } from "rxjs/operators";
import { QueryParamsModel, QueryResultsModel, HttpUtilsService } from "../../_base/crud";
import { environment } from "../../../../environments/environment";
import { Router } from "@angular/router";
import { ApiResponseModel } from "../_models/api-response-model";
import { AccessData } from "./access-data";
import { DashboardWidget } from "app/views/pages/dashboard/dashboard-model/dashboard-widget";

const API_USERS_URL = "api/users";
const API_PERMISSION_URL = "api/permissions";
const API_ROLES_URL = "api/roles";
const API_LOGIN_URL = environment.ApiRoot + "/UserNFC/LoginUser";

import { BroadcastService, MsalService } from "@azure/msal-angular";

@Injectable()
export class AuthService {
	public onCredentialUpdated$: Subject<AccessData>;
	constructor(
		private http: HttpClient, 
		private tokenStorage: TokenStorage, 
		private httpUtils: HttpUtilsService,
		private mSalService: MsalService
	) {
		this.onCredentialUpdated$ = new Subject();
	}
	// Authentication/Authorization
	login(username: string, password: string, redirectUrl: string): Observable<any> {
		let data = {
			username: username,
			password: password,
			redirectUrl: redirectUrl,
		};
		return this.http.post<any>(API_LOGIN_URL, data).pipe(
			map((result: any) => {
				if (result && result.status !== 1) {
					return result.error;
				}
				return result;
			}),
			tap(this.saveAccessData.bind(this)),
			catchError(this.handleError("login", []))
		);
	}

	microsoftAuthen(username: string): Observable<any> {
		return this.http
			.post<any>(environment.ApiRoot + "/UserNFC/MicrosoftAuthen", {
				username: username,
			})
			.pipe(
				map((result: any) => {
					if (result && result.status !== 1) {
						return result.error;
					}
					return result;
				}),
				tap(this.saveAccessData.bind(this)),
				catchError(this.handleError("login", []))
			);
	}

	private saveAccessData(response: ApiResponseModel) {
		if (typeof response !== "undefined" && response.status === 1) {
			this.tokenStorage.clearUserInfo();

			var accessData = {
				accessToken: response.data.Token,
				refreshToken: response.data.Token,
				username: response.data.UserName,
				fullname: response.data.FirstName + " " + response.data.LastName,
				roles: response.data.Rules,
				cocauid: response.data.Cocauid,
				manv: response.data.Manv,
				id: response.data.Id,
				dashboardWidgets: response.data.dashboardWidgets,
				IdChucdanh: response.data.IdChucdanh,
				TenChucDanh: response.data.TenChucDanh,
				email: response.data.Email,
			};
			var f = response.data.Rules.find((x) => x === "280");
			var user = {
				id: accessData.id,
				accessToken: accessData.accessToken,
				roles: accessData.roles,
				username: accessData.username,
				fullname: accessData.fullname,
				cocauid: accessData.cocauid,
				manv: accessData.manv,
				isHanhChanh: f != null,
				IdChucdanh: accessData.IdChucdanh,
				TenChucDanh: accessData.TenChucDanh,
				email: accessData.email,
			};
			this.tokenStorage.setUserInfo(JSON.stringify(user));

			let ConfigDashboardLocalDetail = [];
			accessData.dashboardWidgets.forEach((element) => {
				ConfigDashboardLocalDetail.push({
					Id: element.Id,
					Name: element.Name,
					Component: element.Component,
					RouterLink: element.RouterLink,
					COLS: DashboardWidget.displaySize.MEDIUM.width,
					ROWS: DashboardWidget.displaySize.MEDIUM.height,
					SECTION: 0,
					isShow: true,
				});
			});
			let ConfigDashboardLocal = {
				isSeparate: false,
				ConfigDashboardLocalDetail: ConfigDashboardLocalDetail,
			};

			var dashboardWidgets = {
				widgets: ConfigDashboardLocal,
				lastestUser: "",
			};

			var lastDashboardWidgets: any;
			this.tokenStorage.getDashboardWidgets().subscribe((x) => (lastDashboardWidgets = x));
			let lastUserName = lastDashboardWidgets == null ? null : <string>lastDashboardWidgets.lastestUser;
			// if (lastUserName == null || lastUserName == '' || lastUserName != accessData.username){
			dashboardWidgets.lastestUser = accessData.username;
			this.tokenStorage.clearDashboardConfig();
			this.tokenStorage.setDashboardWidgets(JSON.stringify(dashboardWidgets));
			//}
			this.onCredentialUpdated$.next(accessData);
		} else {
			throwError({ msg: "error" });
		}
	}

	getUserByToken(): Observable<User> {
		const userToken = localStorage.getItem(environment.authTokenKey);
		const httpHeaders = new HttpHeaders();
		httpHeaders.append("Authorization", "Bearer " + userToken);
		return this.http.get<User>(API_USERS_URL, { headers: httpHeaders });
	}

	register(user: User): Observable<any> {
		const httpHeaders = new HttpHeaders();
		httpHeaders.set("Content-Type", "application/json");
		return this.http.post<User>(API_USERS_URL, user, { headers: httpHeaders }).pipe(
			map((res: User) => {
				return res;
			}),
			catchError((err) => {
				return null;
			})
		);
	}
	CreateFCM(): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(environment.ApiRoot + `/nof/CreateFCM`, { headers: httpHeaders });
	}
	DeleteFCM(data): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(environment.ApiRoot + `/nof/DeleteFCM`, data, { headers: httpHeaders });
	}

	/*
	 * Submit forgot password request
	 *
	 * @param {string} email
	 * @returns {Observable<any>}
	 */
	public requestPassword(email: string): Observable<any> {
		return this.http.get(API_USERS_URL + "/forgot?=" + email).pipe(catchError(this.handleError("forgot-password", [])));
	}

	getAllUsers(): Observable<User[]> {
		return this.http.get<User[]>(API_USERS_URL);
	}

	getUserById(userId: number): Observable<User> {
		return this.http.get<User>(API_USERS_URL + `/${userId}`);
	}

	// DELETE => delete the user from the server
	deleteUser(userId: number) {
		const url = `${API_USERS_URL}/${userId}`;
		return this.http.delete(url);
	}

	// UPDATE => PUT: update the user on the server
	updateUser(_user: User): Observable<any> {
		const httpHeaders = new HttpHeaders();
		httpHeaders.set("Content-Type", "application/json");
		return this.http.put(API_USERS_URL, _user, { headers: httpHeaders });
	}

	// CREATE =>  POST: add a new user to the server
	createUser(user: User): Observable<User> {
		const httpHeaders = new HttpHeaders();
		httpHeaders.set("Content-Type", "application/json");
		return this.http.post<User>(API_USERS_URL, user, { headers: httpHeaders });
	}

	// Method from server should return QueryResultsModel(items: any[], totalsCount: number)
	// items => filtered/sorted result
	findUsers(queryParams: QueryParamsModel): Observable<QueryResultsModel> {
		const httpHeaders = new HttpHeaders();
		httpHeaders.set("Content-Type", "application/json");
		return this.http.post<QueryResultsModel>(API_USERS_URL + "/findUsers", queryParams, { headers: httpHeaders });
	}

	// Permission
	getAllPermissions(): Observable<Permission[]> {
		return this.http.get<Permission[]>(API_PERMISSION_URL);
	}

	getRolePermissions(roleId: number): Observable<Permission[]> {
		return this.http.get<Permission[]>(API_PERMISSION_URL + "/getRolePermission?=" + roleId);
	}

	// Roles
	getAllRoles(): Observable<Role[]> {
		return this.http.get<Role[]>(API_ROLES_URL);
	}

	getRoleById(roleId: number): Observable<Role> {
		return this.http.get<Role>(API_ROLES_URL + `/${roleId}`);
	}

	// CREATE =>  POST: add a new role to the server
	createRole(role: Role): Observable<Role> {
		// Note: Add headers if needed (tokens/bearer)
		const httpHeaders = new HttpHeaders();
		httpHeaders.set("Content-Type", "application/json");
		return this.http.post<Role>(API_ROLES_URL, role, { headers: httpHeaders });
	}

	// UPDATE => PUT: update the role on the server
	updateRole(role: Role): Observable<any> {
		const httpHeaders = new HttpHeaders();
		httpHeaders.set("Content-Type", "application/json");
		return this.http.put(API_ROLES_URL, role, { headers: httpHeaders });
	}

	// DELETE => delete the role from the server
	deleteRole(roleId: number): Observable<Role> {
		const url = `${API_ROLES_URL}/${roleId}`;
		return this.http.delete<Role>(url);
	}

	// Check Role Before deletion
	isRoleAssignedToUsers(roleId: number): Observable<boolean> {
		return this.http.get<boolean>(API_ROLES_URL + "/checkIsRollAssignedToUser?roleId=" + roleId);
	}

	findRoles(queryParams: QueryParamsModel): Observable<QueryResultsModel> {
		// This code imitates server calls
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		httpHeaders.set("Content-Type", "application/json");
		return this.http.post<QueryResultsModel>(API_ROLES_URL + "/findRoles", queryParams, { headers: httpHeaders });
	}

	resetSession(): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		httpHeaders.set("Content-Type", "application/json");
		return this.http.post<any>(environment.ApiRoot + "/UserNFC/ResetSession", null, { headers: httpHeaders });
	}

	public logout(refresh?: boolean): void {
		this.tokenStorage.clearUserInfo();
		if (refresh) {
			location.reload();
		}
		if(this.mSalService.getAccount()) {
			this.mSalService.logout();
		}
	}

	getCurrentTime(): Observable<number> {
		return this.http.get<number>(environment.ApiRoot + "/user/current_time");
	}

	/*
	 * Handle Http operation that failed.
	 * Let the app continue.
	 *
	 * @param operation - name of the operation that failed
	 * @param result - optional value to return as the observable result
	 */
	private handleError<T>(operation = "operation", result?: any) {
		return (error: any): Observable<any> => {
			// TODO: send the error to remote logging infrastructure
			console.error("Lỗi", error.message); // log to console instead

			// Let the app keep running by returning an empty result.
			return of(result);
		};
	}
}
